"use client";

import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Image from "next/image";

import resourceGif from "@/assets/images/vpage-resources.gif";
import articleGif from "@/assets/images/article-info.gif";
import testGif from "@/assets/images/test-info.gif";
import styles from "./video-tour.module.scss";
import Components from "@/components";

const tourData = [
  {
    title: "📚 Understand the Course Format",
    details: (
      <ul>
        <li key={0}>&bull; This course is divided into multiple stages.</li>
        <li key={1}>&bull; Each stage contains a combination of:</li>
        <ul>
          <li key={"a"}>&bull; 🎥 Videos</li>
          <li key={"b"}>&bull; 📄 Articles</li>
          <li key={"c"}>&bull; 📝 A Test (always at the end)</li>
        </ul>
        <li key={3}>
          &bull; You must complete all contents in a stage to unlock the next
          one.
        </li>
      </ul>
    ),
    gif: resourceGif,
  },
  {
    title: "🎥 Watch Complete Videos",
    details: (
      <ul>
        <li key={0}>
          &bull; To complete a video, you must watch it completely.
        </li>
        <li key={1}>
          &bull; A ✅ green tick will appear once a video is marked as
          completed.
        </li>
        <li key={2}>
          &bull; Skipping ahead or exiting early will not mark the video as
          complete.
        </li>
      </ul>
    ),
    gif: resourceGif,
  },
  {
    title: "📄 Read and Mark Articles",
    details: (
      <ul>
        <li key={0}>
          &bull; After reading an article, you must click "Mark as Read".
        </li>
        <li key={1}>
          &bull; This will add a ✅ green tick next to the article.
        </li>
        <li key={2}>
          &bull; Both videos and articles are equally required to proceed to the
          test.
        </li>
      </ul>
    ),
    gif: articleGif,
  },
  {
    title: "📝 Test: The Final Step in Each Stage",
    details: (
      <ul>
        <li key={0}>
          &bull; The test becomes available only after all videos and articles
          are completed.
        </li>
        <li key={1}>&bull; You have 3 attempts to score above 50%.</li>
        <li key={2}>&bull; Your result is evaluated and shown after 1 hour.</li>
        <li key={2}>
          &bull; Passing the test completes the stage and unlocks the next one.
        </li>
      </ul>
    ),
    gif: testGif,
  },
];

function VideoPageTour(props) {
  const { closeHandler, skipHandler } = props;
  const [contentSelect, setContentSelect] = useState(0);
  const [progress, setProgress] = useState("0%");

  const handleNextClick = (e) => {
    e.preventDefault();
    if (contentSelect + 1 <= tourData?.length) {
      setContentSelect((prev) => prev + 1);
    }
  };

  useEffect(() => {
    tourData[[contentSelect]];
    const total = tourData?.length - 1;
    const _prog = (contentSelect / total) * 100;
    setProgress(_prog + "%");
  }, [contentSelect]);

  const handlePrevious = (e) => {
    e.preventDefault();
    if (contentSelect - 1 < 0) return;
    setContentSelect((prev) => prev - 1);
  };

  return (
    <section className={styles.container}>
      <Icon icon={"system-uicons:cross"} onClick={skipHandler} />
      <div className={styles.img}>
        <Image src={tourData[contentSelect]?.gif} alt="tour-gif" />
      </div>
      <article className={styles["sub-container"]}>
        <div className={styles.header}>
          <h2>{tourData[contentSelect].title}</h2>
        </div>
        {tourData[contentSelect]?.details}
      </article>

      <div className={styles["footer"]}>
        <div className={styles["progress-container"]}>
          <div
            className={styles["progressbar"]}
            style={{ width: progress }}
          ></div>
        </div>

        <div className={styles["btn-container"]}>
          <Components.Button
            className={styles["skip-btn"]}
            name={"Skip"}
            handleClick={skipHandler}
          />
          <div className={styles.right}>
            {contentSelect === 0 ? (
              <Components.Button
                className={styles.btn}
                name={"Next"}
                handleClick={handleNextClick}
              />
            ) : (
              <>
                <Components.Button
                  className={styles["prev-btn"]}
                  name={"Previous"}
                  handleClick={handlePrevious}
                />

                <Components.Button
                  className={styles.btn}
                  name={
                    contentSelect === tourData.length - 1 ? "Let’s Go!" : "Next"
                  }
                  handleClick={
                    contentSelect === tourData.length - 1
                      ? closeHandler
                      : handleNextClick
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoPageTour;
